const STATE_PENDING = 'pending'
const STATE_VALIDATED = 'validated'
const STATE_CREATED = 'created'
const STATE_SCHEDULED = 'scheduled'
const STATE_COURIER_CONFIRMED = 'courierconfirmed'
const STATE_APPROACH = 'approach'
const STATE_TRANSIT = 'transit'
const STATE_DELIVERED = 'delivered'
const STATE_APPLIED = 'applied'
const STATE_SCHEDULED_APPLIED = 'scheduled_applied'
const STATE_CANCELED = 'canceled'

export const DELIVERY_STATE = {
  PENDING: STATE_PENDING,
  VALIDATED: STATE_VALIDATED,
  CREATED: STATE_CREATED,
  SCHEDULED: STATE_SCHEDULED,
  COURIER_CONFIRMED: STATE_COURIER_CONFIRMED,
  APPROACH: STATE_APPROACH,
  TRANSIT: STATE_TRANSIT,
  DELIVERED: STATE_DELIVERED,
  APPLIED: STATE_APPLIED,
  SCHEDULEDED_APPLIED: STATE_SCHEDULED_APPLIED,
} as const

export type DELIVERY_STATE = typeof DELIVERY_STATE[keyof typeof DELIVERY_STATE]

const STATE_STARTED = 'started'
const STATE_PICKING_CONFIRMED = 'picking_confirmed'
const STATE_DELIVERED_CONFIRMED = 'delivered_confirmed'
const STATE_BILLABLE = 'billable'
const STATE_BILLED = 'billed'
const STATE_ALL = 'all'

export const OPERATOR_STATE = {
  PENDING: STATE_PENDING,
  CREATED: STATE_CREATED,
  STARTED: STATE_STARTED,
  PICKING_CONFIRMED: STATE_PICKING_CONFIRMED,
  DELIVERED_CONFIRMED: STATE_DELIVERED_CONFIRMED,
  BILLABLE: STATE_BILLABLE,
  BILLED: STATE_BILLED,
  CANCELED: STATE_CANCELED,
  ALL: STATE_ALL,
} as const

export type OPERATOR_STATE = typeof OPERATOR_STATE[keyof typeof OPERATOR_STATE]

const TRANSIT_TIME_TO_BE_CONFIRMED = 'toBeConfirmed'
const TRANSIT_TIME_ESTIMATED_ROUTING = 'estimatedRouting'
const TRANSIT_TIME_REALISTIC = 'realistic'
const TRANSIT_TIME_CUSTOM = 'custom'

export const TRANSIT_TIME = {
  TO_BE_CONFIRMED: TRANSIT_TIME_TO_BE_CONFIRMED,
  ESTIMATED_ROUTING: TRANSIT_TIME_ESTIMATED_ROUTING,
  REALISTIC: TRANSIT_TIME_REALISTIC,
  CUSTOM: TRANSIT_TIME_CUSTOM,
}

const COUNTRIES = [
  { value: 'fr', label: 'FRA', name: 'France' },
  { value: 'mc', label: 'MC', name: 'Monaco' },
  { value: 'es', label: 'ESP', name: 'Spain' },
  { value: 'it', label: 'ITA', name: 'Italy' },
  { value: 'de', label: 'ALL', name: 'Germany' },
  { value: 'uk', label: 'ANG', name: 'United Kingdom' },
  { value: 'lux', label: 'LUX', name: 'Luxembourg' },
  { value: 'ch', label: 'SUI', name: 'Switzerland' },
  { value: 'bel', label: 'BEL', name: 'Belgium' },
  { value: 'nld', label: 'NLD', name: 'Netherlands' },
  { value: 'pol', label: 'POL', name: 'Poland' },
  { value: 'ro', label: 'ROU', name: 'Romania' },
  { value: 'pt', label: 'POR', name: 'Portugal' },
  { value: 'dk', label: 'DAN', name: 'Denmark' },
  { value: 'cz', label: 'CZE', name: 'Czechia' },
  { value: 'at', label: 'AUT', name: 'Austria' },
  { value: 'bg', label: 'BUL', name: 'Bulgaria' },
  { value: 'cy', label: 'CYP', name: 'Cyprus' },
  { value: 'hr', label: 'HRV', name: 'Croatia' },
  { value: 'ee', label: 'EST', name: 'Estonia' },
  { value: 'fi', label: 'FIN', name: 'Finland' },
  { value: 'gr', label: 'GRC', name: 'Greece' },
  { value: 'hu', label: 'HUN', name: 'Hungary' },
  { value: 'ie', label: 'IRL', name: 'Ireland' },
  { value: 'lv', label: 'LVA', name: 'Latvia' },
  { value: 'lt', label: 'LTU', name: 'Lithuania' },
  { value: 'mt', label: 'MLT', name: 'Malta' },
  { value: 'sk', label: 'SVK', name: 'Slovakia' },
  { value: 'si', label: 'SVN', name: 'Slovenia' },
  { value: 'se', label: 'SWE', name: 'Sweden' },
]

export const COUNTRY_OPTIONS = COUNTRIES.sort((a, b) => {
  if (a.value === 'fr') return -1;
  if (b.value === 'fr') return 1;
  return a.label.localeCompare(b.label);
});



